import api from '../api';

export interface CompanyIdentity {
  bin: string;
  nameRu: string | null;
  nameKz: string | null;
}

// Identity-only autocomplete shared with experience calculation. This existing
// endpoint requires a login, but no subscription or calculation credits.
export const getCompanySuggestions = (q: string, signal?: AbortSignal) =>
  api.get<{ items: CompanyIdentity[] }>('/experience/companies', {
    params: { q, limit: 8 }, signal, timeout: 15000,
  }).then(response => response.data);
